export default __webpack_public_path__ + "static/media/RR-logo.545ae7fc.png";